import React, { useEffect,useState } from 'react'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear , faCirclePlus , faCircleArrowLeft , faMoneyBills} from '@fortawesome/free-solid-svg-icons';
import { ReactSession } from 'react-client-session';
import Header from '../../components/Header'; 
import { useTokenCreatorFactoryContract } from '../../hooks/useContracts';
import { CreateStandartToken , CreateLiquidityGeneratorBurnToken ,CreateLiquidityGeneratorToken } from '../../utils/contractCalls';
import toast, { Toaster } from 'react-hot-toast';
import styled from 'styled-components';
import CreateFees , {CreateFeesAVAX, TotalCreatedCount} from '../../hooks/useContractFactory';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import SelectNetwork from './components/SelectNetwork';
import MenuButtons from '../../components/MenuButtons';


function CreateToken() {

     document.title = "Altcoinator | Erc20 Token Generator";

     const ethereum = window?.ethereum;

    const isMetamask =  typeof ethereum !== 'undefined';
     
     const {account , connect} = useWallet();

     const [selectType,setselectType] = useState(1);

     const factoryContract = useTokenCreatorFactoryContract();

     const [name,setName] = useState("");
     const [symbol,setSymbol] = useState("");
     const [decimal,setDecimal] = useState("");
     const [supply,setSupply] = useState("");
     const [marketingWallet,setmarketingWallet] = useState("");
     const [taxFee,settaxFee] = useState("");
     const [liqFee,setliqFee] = useState("");
     const [marketingFee,setmarketingFee] = useState("");
     const [burnFee,setburnFee] = useState("");
     const [router,setRouter] = useState(ReactSession.get("network").routers[0].address);

     const [loading,setLoading] = useState(false);
     const [contractAddr, setcontractAddr] = useState("");

     const [success,setSuccess] = useState(false);
     const [successSelectType,setsuccessSelectType] = useState(1);

      const fees = ReactSession.get("network").networkname == 'AVAX' ?  CreateFeesAVAX() : CreateFees();
      const totalCreated = TotalCreatedCount();

      const ref = account == ReactSession.get("refwallet") ? "0x0000000000000000000000000000000000000000" : ReactSession.get("refwallet");

      const [isChecked, setIsChecked] = useState(false);

      const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
      };

       
 
     const Load = styled.div`
     width: 45px;
     height: 45px;
     border-radius: 50%;
     border: 6px solid #0000;
     border-right-color: #86FF00;
     position: relative;
     animation: s4 1s infinite linear;

     &:after {
        content: "";
    position: absolute;
    inset:-4px;
    border-radius: 50%;
    border:inherit;
    animation:inherit;
    animation-duration: 2s;
    animation-duration: 4s;
      }

      @keyframes s4 {
        100% {transform: rotate(1turn)}
      }
       `;

       const SuccessCard = styled.div`
        padding:20px;
        border-radius:10px;
        background-color:#09121D;
        border:solid 1px black;
        color:white;
        text-align:center;
       `;

     const create = () =>{
        if(!isChecked){
             toast.error("Please Confirm the Terms of Use.");
        }
        else{

            if(selectType == 1 || selectType == 2){
            let mintable = selectType == 2 ? true : false;
            if(name=="" || symbol=="",decimal=="",supply==""){
                toast.error("Fill in the required fields");
            }else{
                setLoading(true);
                CreateStandartToken(factoryContract,ref,name,symbol,decimal,supply,mintable,(fees[selectType-1]/1e18),account).then((e)=>{
                    setcontractAddr(e.events.CreateToken.returnValues.tokenAddr);
                    setLoading(false);
                    setSuccess(true); 
                }).catch((err)=>{
                    if(err.code==4001){
                        setLoading(false)
                    }
                });
            }
        }else if(selectType == 3){

            if(name=="" || symbol=="",decimal=="",supply=="" || marketingWallet =="" || taxFee=="" || liqFee =="" || marketingFee==""){
                toast.error("Fill in the required fields");
            }else{
                if((parseInt(taxFee) + parseInt(liqFee) + parseInt(marketingFee)) <= 25){
                    setLoading(true);
                    CreateLiquidityGeneratorToken(factoryContract,ref,name,symbol,decimal,supply,router,marketingWallet,taxFee,liqFee,marketingFee,(fees[selectType-1]/1e18),account).then((e)=>{
                        setcontractAddr(e.events.CreateToken.returnValues.tokenAddr);
                        setsuccessSelectType(3)
                        setLoading(false);
                        setSuccess(true);
                    }).catch((err)=>{
                        if(err.code==4001){
                            setLoading(false)
                        }
                    });
                }else{
                    toast.error("The total of the fees cannot exceed 25.");
                }
                
            } 
           
        }else if(selectType == 4){
             
            if(name=="" || symbol=="",decimal=="",supply=="" || marketingWallet =="" || taxFee=="" || liqFee =="" || marketingFee=="" || burnFee==""){
                toast.error("Fill in the required fields");
            }else{
                if((parseInt(taxFee) + parseInt(liqFee) + parseInt(marketingFee) + parseInt(burnFee)) <= 25){
                setLoading(true);
                CreateLiquidityGeneratorBurnToken(factoryContract,ref,name,symbol,decimal,supply,router,marketingWallet,taxFee,liqFee,marketingFee,burnFee,(fees[selectType-1]/1e18),account).then((e)=>{
                    setcontractAddr(e.events.CreateToken.returnValues.tokenAddr);
                    setsuccessSelectType(4);
                    setLoading(false);
                    setSuccess(true);
                }).catch((err)=>{
                    if(err.code==4001){
                        setLoading(false)
                    }
                });
                }else{
                    toast.error("The total of the fees cannot exceed 25.");
                }
            }
        }

        }

        
     }

     return ( 
     <>
    <div id="wrapper">
      <Header />
      <section className="tf-section tf-wallet"  >
        <div style={{maxWidth:"760px"}} className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="wallet-form">
               <iframe  className='w-100' height={200} src="https://www.youtube.com/embed/atHXHFWw9nY" title="How To Create ERC20 Token (No Code)" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>

              <hr/>
                <MenuButtons/>  
              <hr/>
                <h4>Create ERC20 Token</h4>
                <p className="sub">Please Choose network,  &amp; connect your wallet and start token create</p>
                <div className="spacing" />

                    <div className='d-block d-sm-none'>
                     <div className='alert alert-info'> If you entered the site from mobile, you entered the site url from the browser in the metamask application. </div>
                </div>
     
                     {isMetamask ? ("") : (<>
                    <div className='alert alert-warning'>Metamask does not appear to be installed. <a href='https://metamask.io/download/'>Click to install.</a> </div>
                </>)}
                    <SelectNetwork/>
                    <div className="connect-wallet">
                    {success ? (
                        <div id="success-card">
                        <hr/>
                           <SuccessCard>
                               <img width={80} src='assets/images/confirm-icon.png'/> <br/>
                               Token Created!<br/>
                               <a target="_blank" href={'https://testnet.bscscan.com/token/'+contractAddr}> {contractAddr}</a><br/> <br/>
                               Name: <b style={{color:"#86FF00"}}>{name}</b>  <br/>
                               Symbol: <b style={{color:"#86FF00"}}>{symbol}</b>  <br/>
                               Decimal: <b style={{color:"#86FF00"}}>{decimal}</b>   <br/>
                               Supply: <b style={{color:"#86FF00"}}>{(supply).toLocaleString()} {symbol}</b>  <br/>
                               {successSelectType ==3 ? (<>
                                   Marketing Wallet: <b style={{color:"#86FF00"}}>{marketingWallet}</b><br/>
                               Tax Fee: <b style={{color:"#86FF00"}}>{taxFee}%</b><br/>
                               Liquidity Fee: <b style={{color:"#86FF00"}}>{liqFee}%</b><br/>
                               </>) : successSelectType == 4 ? (<>
                                   Burn Fee: <b style={{color:"#86FF00"}}>{burnFee}%</b>
                               </>) : null }
                           </SuccessCard>
                       <hr/>
                      </div>
                    ) : null }
                    <hr />
                    <div style={{float:"left"}}> Create Fee: {fees[selectType-1]/1e18} {ReactSession.get("network").symbol} </div><div style={{float:"right"}}> Total Created: {totalCreated} </div><br/>  
                    <hr />
                    <h6>Enter Token Informations</h6>
                     {selectType ==2 ? (<div className='alert alert-warning'>If you choose this option, you can increase the supply of your token unlimitedly.</div>) : 
                      null}
                    <div className="form-inner">
                      <fieldset>
                        <label> Token Type </label>
                        <select onChange={(e)=>{setselectType(e.target.value)}}>
                          <option value={1}>Standart Token</option>
                          <option value={2}>Standart Mintable Token</option>
                         {ReactSession.get("network").networkname != 'AVAX' ? (
                            <>
                            <option value={3}>Liquidity Generator Token</option>
                          <option value={4}>Liquidity Generator + Burnable Token</option>
                            </>
                          ) : ""}
                        </select>
                      </fieldset>
                      <br/>
                      <div id="standard-or-mintable">
                          <div className='row'>
                          <div className='col-lg-6'>
                              <fieldset>
                              <label> Token Name* </label>
                              <input type="text" onChange={(e)=>{setName(e.target.value)}} value={name} placeholder="Ex: Bitcoin" required style={{background:"#171F29"}} />
                              </fieldset>
                          </div>
                          <div className='col-lg-6'>
                              <fieldset>
                              <label> Token Symbol* </label>
                              <input type="text" onChange={(e)=>{setSymbol(e.target.value)}} value={symbol} placeholder="Ex: BTC" required style={{background:"#171F29"}} />
                              </fieldset>
                          </div>
                          </div>
                          <br/>
                          <div className='row'>
                          <div className='col-lg-6'>
                              <fieldset>
                              <label> Token Decimal* </label>
                              <input type="number" onChange={(e)=>{setDecimal(e.target.value)}} value={decimal} placeholder="Ex: 18" min={1} max={18} required style={{background:"#171F29"}} />
                              </fieldset>
                          </div>
                          <div className='col-lg-6'>
                              <fieldset>
                              <label> Supply* </label>
                              <input type="number" onChange={(e)=>{setSupply(e.target.value)}} value={supply} placeholder="Ex: 21000000" min={1} required style={{background:"#171F29"}} />
                              </fieldset>
                          </div>
                          </div>
                      </div>
                      <br/>
                       {selectType == 3 ||  selectType == 4 ? (
                          <div id="liquidity-generator-token">
                          <div className='row'>
                              <div className='col-lg-12'>
                                  <fieldset>
                                  <label> Marketing Wallet* </label>
                                  <input type="text" onChange={(e)=>{setmarketingWallet(e.target.value)}} value={marketingWallet}  placeholder="Ex: 0x0000000000000000000000000000000000000000" required style={{background:"#171F29"}} />
                                  </fieldset>
                              </div>
                          </div>
                          <br/>
                          <div className='row'>
                          <div className={selectType == 3 ? 'col-lg-4' : 'col-lg-3'}>
                              <fieldset>
                              <label> Tax Fee* </label>
                              <input type="number" onChange={(e)=>{settaxFee(e.target.value)}} value={taxFee} placeholder="Ex: 5" min={1} max={18} required style={{background:"#171F29"}} />
                              </fieldset>
                          </div>
                          <div className={selectType == 3 ? 'col-lg-4' : 'col-lg-3'}>
                              <fieldset>
                              <label> Liquidity Fee* </label>
                              <input type="number" onChange={(e)=>{setliqFee(e.target.value)}} value={liqFee} placeholder="Ex: 5" min={1} required style={{background:"#171F29"}} />
                              </fieldset>
                          </div>
                          <div className={selectType == 3 ? 'col-lg-4' : 'col-lg-3'}>
                              <fieldset>
                              <label> Marketing Fee* </label>
                              <input type="number" onChange={(e)=>{setmarketingFee(e.target.value)}} value={marketingFee} placeholder="Ex: 5" min={1} required style={{background:"#171F29"}} />
                              </fieldset>
                          </div>
                          {selectType == 4 ? (
                              <div className={selectType == 3 ? 'col-lg-4' : 'col-lg-3'}>
                              <fieldset>
                              <label> Burn Fee* </label>
                              <input type="number" onChange={(e)=>{setburnFee(e.target.value)}} value={burnFee} placeholder="Ex: 5" min={1} required style={{background:"#171F29"}} />
                              </fieldset>
                          </div>
                          ) : null}
                          </div>
                          <br/>
                          <div className='row'>
                              <div className='col-lg-12'>
                                  
                                        <fieldset>
                                        <label> Router* </label>
                                        <select onChange={(e)=>{setRouter(e.target.value)}}  >
                                        {ReactSession.get("network").routers.map((e,index)=>{
                                            
                                             return (
                                                  <option value={e.address}>{e.name}</option>
                                              );
                                            })}
                                        </select>
                                     </fieldset>
                              </div>
                          </div>
                          <br/>
                      </div>
                      ) :  null }

                      <div className='alert alert-success'>
                        <div class="form-group form-check">
                            <input type="checkbox" 
                            class="form-check-input" 
                            id="exampleCheck1" 
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                            />
                            <label class="form-check-label" for="exampleCheck1">I have read, understood and agreed to Altcoinator <a href="#" data-toggle="modal" data-target="#popup_bid" style={{textDecoration:"underline"}}>Terms of Use.</a></label>
                        </div>
                            
                        </div>

                    </div>
                    <br/>
                  </div>
                {!loading ? (
                    <div className="bottom">
                        <div className="wrap-btn">
                            <button type="submit" onClick={!account ? ()=>{connect("injected")} : create} className="tf-button style2 w-100">
                            {account ? "Create Token" : "Connect Wallet"}  
                            </button>
                        </div>
                    </div>
                ) : (<center><Load/> Creating Token...</center>)}
                
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footer/>
  </> 
  ); 
} 

export default CreateToken;
